import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "my-2" }
const _hoisted_2 = { class: "flex items-center justify-between px-2" }
const _hoisted_3 = { class: "md:text-lg leading-4 font-semibold text-gray-900" }
const _hoisted_4 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_5 = { class: "md:text-sm text-xs hover:underline" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "md:text-center pl-2 pt-2 md:p-0 text-sm md:text-base" }
const _hoisted_8 = {
  key: 0,
  class: "md:flex md:gap-4 py-1 px-2 hidden"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "w-6 px-2 mr-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "delete")
], -1)
const _hoisted_10 = { class: "text-xs inline-flex md:hidden col-span-1 font-bold" }
const _hoisted_11 = {
  key: 0,
  class: "col-span-2"
}
const _hoisted_12 = {
  key: 1,
  class: "col-span-2"
}
const _hoisted_13 = ["name", "disabled", "value", "onInput", "id", "onKeydown"]
const _hoisted_14 = {
  key: 0,
  class: "text-red block"
}
const _hoisted_15 = {
  key: 1,
  class: "text-red block"
}
const _hoisted_16 = {
  key: 2,
  class: "col-span-2"
}
const _hoisted_17 = ["value", "onInput", "placeholder", "id", "onKeydown"]
const _hoisted_18 = {
  key: 1,
  class: "w-1/2 md:w-full"
}
const _hoisted_19 = { class: "text-left text-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CalendarIcon = _resolveComponent("CalendarIcon")!
  const _component_PencilIcon = _resolveComponent("PencilIcon")!
  const _component_CopySectionData = _resolveComponent("CopySectionData")!
  const _component_SelectCombobox = _resolveComponent("SelectCombobox")!
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!
  const _component_PlusIcon = _resolveComponent("PlusIcon")!

  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editMode ? _ctx.$emit('addHighlight') : '')),
    class: _normalizeClass([
      {
        'shadow-lg mix-blend-normal bg-blend-color-dodge': _ctx.editMode,
        'border-yellow': _ctx.highlightSection === _ctx.section,
      },
      'my-4 bg-white shadow sm:rounded-lg md:px-5 px-1 py-6 border',
    ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t(`report.section_title.${_ctx.section}`)), 1),
        (!_ctx.approved)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("button", {
                class: "flex items-center text-orange text-sm",
                onClick: _cache[0] || (_cache[0] = ($event: any) => {
              _ctx.copyDataOpen = true;
              _ctx.searchDate = _ctx.yesterday;
            })
              }, [
                _createVNode(_component_CalendarIcon, { class: "md:h-4 h-3 pr-1" }),
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("report.general.old_data_label")), 1)
              ]),
              (!_ctx.editMode)
                ? (_openBlock(), _createBlock(_component_PencilIcon, {
                    key: 0,
                    class: "md:w-4 md:h-4 h-3 text-oaiGray-300 cursor-pointer ml-3",
                    onClick: _ctx.activeEditMode
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_CopySectionData, {
          open: _ctx.copyDataOpen,
          date: _ctx.searchDate,
          onCloseModal: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copyDataOpen = false)),
          onCopySectionData: _cache[2] || (_cache[2] = ($event: any) => (_ctx.copySectionData($event), (_ctx.copyDataOpen = false)))
        }, null, 8, ["open", "date"])
      ]),
      (_ctx.approved && _ctx.entries.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("report.general.section_empty")), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.editMode ? 'editInput' : 'overviewInput'])
    }, [
      (_ctx.entries.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectionConfig, (field, key) => {
              return (_openBlock(), _createElementBlock("div", {
                key: key,
                class: _normalizeClass([
            field.width,
            'flex-wrap md:flex-nowrap font-medium text-gray-600 gap-2 md:gap-4 flex justify-between',
          ])
              }, _toDisplayString(_ctx.$t(`report.sections.${_ctx.section}.${key}`)), 3))
            }), 128)),
            _hoisted_9
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entries, (entry, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: idx,
          class: _normalizeClass([
          'flex flex-wrap md:flex-nowrap px-2 py-2 gap-2 md:gap-4 relative tableRow border-t border-gray-200',
          {
            'items-center': !_ctx.validationError,
          },
        ])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry, (value, name, entryIdx) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: entryIdx }, [
              (_ctx.hasKey(name))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass([
              _ctx.sectionConfig[name]['width'],
              `order-${_ctx.sectionConfig[name]['order']}`,
              'grid grid-cols-3 md:grid-cols-1',
            ])
                  }, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t(`report.sections.${_ctx.section}.${name}`)), 1),
                    (_ctx.sectionConfig[name]['field_type'] === 'combobox')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createVNode(_component_SelectCombobox, {
                            onUpdateEvent: ($event: any) => (_ctx.$emit('updateComboBox', _ctx.section, name, $event, idx)),
                            onAddCustomField: ($event: any) => (
                  _ctx.$emit('addCustomField', $event, _ctx.section, name),
                    _ctx.$emit('updateComboBox', _ctx.section, name, $event, idx)
                ),
                            onDeleteCustomField: ($event: any) => (_ctx.$emit('deleteCustomField', $event, _ctx.section, name)),
                            onNextFocus: ($event: any) => (_ctx.nextFocus($event, idx, name)),
                            onDirectFocus: ($event: any) => (_ctx.focusInputField(_ctx.section, idx, name)),
                            editMode: _ctx.$props.editMode,
                            customFields: _ctx.sortSavedOptions(_ctx.customFields[name], name),
                            initialSelectedOption: entry[name],
                            error: _ctx.validationError,
                            typeOfData: name,
                            keyData: _ctx.section,
                            tablePosition: { row: idx, firstCol: _ctx.isFirstCol(name) }
                          }, null, 8, ["onUpdateEvent", "onAddCustomField", "onDeleteCustomField", "onNextFocus", "onDirectFocus", "editMode", "customFields", "initialSelectedOption", "error", "typeOfData", "keyData", "tablePosition"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.sectionConfig[name]['field_type'] === 'number')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("input", {
                            type: "number",
                            name: name,
                            disabled: !_ctx.editMode,
                            class: _normalizeClass({ 'oai-inputs': _ctx.editMode }),
                            min: "0",
                            step: "1",
                            value: entry[name],
                            onInput: ($event: any) => (_ctx.$emit('updateFieldValue', $event, _ctx.section, idx)),
                            id: `input-${_ctx.section}-${idx}-${name}`,
                            onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.nextFocus($event, idx, name)), ["prevent"]), ["enter"])
                          }, null, 42, _hoisted_13),
                          (entry[name] < 0 && _ctx.validationError)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_14, _toDisplayString(_ctx.$t("err.negative_value")), 1))
                            : _createCommentVNode("", true),
                          (entry[name] === '' && entry[name] !== '0' && _ctx.validationError)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_15, _toDisplayString(_ctx.$t("err.required")), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.sectionConfig[name]['field_type'] === 'textarea')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          (_ctx.editMode)
                            ? (_openBlock(), _createElementBlock("textarea", {
                                key: 0,
                                rows: "2",
                                name: "note",
                                value: entry[name],
                                onInput: ($event: any) => (_ctx.$emit('updateFieldValue', $event, _ctx.section, idx)),
                                placeholder: _ctx.$t('report.general.notes_placeholder'),
                                class: _normalizeClass({ 'oai-inputs': _ctx.editMode }),
                                id: `input-${_ctx.section}-${idx}-${name}`,
                                onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.nextFocus($event, idx, name)), ["prevent"]), ["enter"])
                              }, null, 42, _hoisted_17))
                            : _createCommentVNode("", true),
                          (!_ctx.editMode)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _createElementVNode("p", _hoisted_19, _toDisplayString(entry[name] !== "" ? entry[name] : "-"), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          _createElementVNode("button", {
            class: _normalizeClass(['flex justify-end md:order-last order-first', _ctx.editMode ? 'mr-3' : 'mr-9'])
          }, [
            (_ctx.editMode)
              ? (_openBlock(), _createBlock(_component_XMarkIcon, {
                  key: 0,
                  class: "w-6 text-red-900 hover:text-red",
                  onClick: ($event: any) => (_ctx.$emit('removeEntry', entry, _ctx.section))
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ], 2)
        ], 2))
      }), 128))
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(['flex justify-center', { 'mt-5': _ctx.editMode }])
    }, [
      ((_ctx.editMode || _ctx.entries.length === 0) && !_ctx.approved)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addNewEntry && _ctx.addNewEntry(...args))),
            class: "relative inline-flex items-center p-2 shadow-sm border-2 border-yellow rounded-full text-yellow-700 hover:bg-yellow-700 hover:text-white focus:outline-none"
          }, [
            _createVNode(_component_PlusIcon, { class: "w-6" })
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}